<script setup>

import {ref, onMounted, reactive} from "vue";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import Button from 'primevue/button';
import Paginator from 'primevue/paginator';
import InputText from "primevue/inputtext";
import swal from 'sweetalert';
import DatePicker from 'primevue/datepicker';
import Dialog from 'primevue/dialog';



const filter = reactive({
    uuid: null,
    exception: null,
    entity:null,
    data_inicio:null,
    data_fim:null
});

const loading = ref(false);
const selectJobs = ref([]);
const jobs = ref([]);
const dadosModal = reactive({
    titulo:'Modal',
    conteudo : ''
});
const modalShow =  ref(false);
const paginate = reactive({
    rows: 10,
    total: 0,
    to: 0
})

const showPayload = (titulo='',conteudo='') =>{
    dadosModal.titulo = titulo;
    dadosModal.conteudo = conteudo;
    modalShow.value = true;
}

const getJobs = async (options = {}) => {

    loading.value = true;
    let {page, rows} = options;

    const {uuid, exception,entity,data_inicio,data_fim} = filter;
    const search = {uuid, exception,entity,data_inicio,data_fim};
    const params = new URLSearchParams({
        page: page ? ++page : 1,
        perPage: rows ? rows : 10,
        search: JSON.stringify(search)
    });

    try {
        const resp = await axios.get("/api/jobs/failed?" + params.toString());
        loading.value = false;
        const data = await resp.data;
        jobs.value = data.data;
        paginate.rows = data.per_page;
        paginate.total = data.total;
        paginate.to = data.to;
    }catch (e){
        swal("Erro","ocorreu um erro no carregamento!",'error');
        loading.value = false;
    }

}


const retry = async () => {

    const failed_uuids = [];

    selectJobs.value.forEach(e => {
        failed_uuids.push(e.uuid);
    });

    loading.value = true;
    try {
        const resp = await axios.post("/api/jobs/failed/retry-many", {failed_uuids});
        const data = await resp.data;
        selectJobs.value = [];
    } catch (e) {
        if (e.response && e.response.status === 400) {
            swal("Erro", e.response.data.message, "error");
        }
    }

    loading.value = false;
    await getJobs();
}

const destroy = async () => {
    const failed_uuids = [];

    selectJobs.value.forEach(e => {
        failed_uuids.push(e.uuid);
    });

    loading.value = true;

    try {
        const resp = await axios.post("/api/jobs/failed/destroy-many", {failed_uuids});
        const data = await resp.data;
        await getJobs();
    }catch (e) {
        swal("Erro", e.response.data.message, "error");
    }

    loading.value = false;

}

const clear = () => {
    filter.uuid = '';
    filter.exception = '';
    filter.entity = '';
    filter.data_fim = '';
    filter.data_inicio = '';
    getJobs();
}

onMounted(() => {
    getJobs();
})

const trataHtml = (text) =>{
    return text.split("#").join("<br>#");
}
</script>

<template>
    <Dialog v-model:visible="modalShow"
            maximizable
            modal
            :header="dadosModal.titulo"
            :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
        <p class="m-0">
         <div v-html="trataHtml(dadosModal.conteudo)" v-if="dadosModal.titulo == 'Exception'"></div>
         <div  v-if="dadosModal.titulo == 'Payload'">
             {{dadosModal.conteudo}}
         </div>
        </p>
    </Dialog>

    <div class="container-fluid">
        <DataTable
            v-model:selection="selectJobs"
            :value="jobs"
            :loading="loading"
        >
            <template #header>
                <div class="d-flex  flex-row flex-wrap justify-content-end items-end">
                    <Button icon="pi pi-refresh" rounded raised @click="getJobs"/>
                </div>
                <div class="d-flex flex-wrap justify-content-center align-items-center">
                    <DatePicker placeholder="Data inicio"   class="m-2" v-model="filter.data_inicio" dateFormat="dd/mm/yy"  />
                    <DatePicker placeholder="Data Fim" class="m-2" v-model="filter.data_fim" dateFormat="dd/mm/yy"  />
                    <InputText placeholder="UUID" class="m-2" v-model="filter.uuid"/>
                    <InputText placeholder="class" class="m-2" v-model="filter.entity"/>
                    <InputText placeholder="Exception" class="m-2" v-model="filter.exception"/>
                    <div>
                        <Button raised rounded icon="pi pi-search" label="Pesquisar" title="Pesquisar" class="m-2"
                                @click="getJobs"></Button>
                        <Button raised rounded icon="pi pi-filter-slash" label="Limpar Filtro" title="Limpar" class="m-2"
                                @click="clear"></Button>
                        <Button raised rounded icon="pi pi-refresh" label="Reprocessar" v-if="selectJobs.length"
                                title="Reprocessar" class="m-2" @click="retry"></Button>
                        <Button raised rounded icon="pi pi-trash" label="Excluir" v-if="selectJobs.length" title="Excluir"
                                class="m-2" @click="destroy"></Button>
                    </div>
                </div>
            </template>
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="id" header="ID" style="min-width: 12rem">
                <template #body="{ data }">
                    {{ data.id }}
                </template>
            </Column>
            <Column field="failed_at" header="Data"></Column>
            <Column field="uuid" header="UUID"></Column>
            <Column field="payload" header="Class">
                <template #body="{ data }">
                    {{ JSON.parse(data.payload).displayName }}
                </template>
            </Column>
            <Column field="connection" header="Connection"></Column>
            <Column field="queue" header="Queue"></Column>
            <Column field="payload" header="Payload">
                <template #body="{ data }">
                    <Button @click="showPayload('Payload',data.payload)" icon="pi pi-eye"></Button>
                </template>
            </Column>
            <Column field="exception" header="Exception">
                <template #body="slotProps">
                    {{ slotProps.data.exception.split("Stack trace")[0] }}
                    <Button @click="showPayload('Exception',slotProps.data.exception)" icon="pi pi-eye"></Button>
                </template>
            </Column>
        </DataTable>
        <Paginator :rows="paginate.rows"
                   :totalRecords="paginate.total"
                   :rowsPerPageOptions="[10, 20, 30,50,80,100]"
                   @page="getJobs"
        >
            <template #start>
                {{ paginate.to }} de {{ paginate.total }}
            </template>
        </Paginator>
    </div>

</template>

<style scoped>

</style>
